import { ArrowForwardIcon } from "@chakra-ui/icons";
import {
  VStack,
  GridItem,
  Heading,
  Button,
  Divider,
  Text,
  ButtonGroup,
  Box,
} from "@chakra-ui/react";
import { Formik } from "formik";
import TextInput from "../../form/fields/text";
import Section from "../../form/section";
import {
  organisationValidation,
  VicFormsRegistrationScreenComponent,
  VicFormsRegistrationScreens,
} from "./models";

const Organisation: React.FC<VicFormsRegistrationScreenComponent> = ({
  onSubmit,
  initialValues,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={organisationValidation}
      onSubmit={(values) => {
        onSubmit(values, VicFormsRegistrationScreens.PRIMARY_CONTACT);
      }}
    >
      {({ handleSubmit, isSubmitting }) => {
        return (
          <form style={{ width: "100%" }} noValidate onSubmit={handleSubmit}>
            <VStack spacing={4} p={2} align={"stretch"} divider={<Divider />}>
              <Box>
                <Heading mb={4}>Create your account</Heading>
                <Text>
                  We're so glad you're here! Let's create your account so you
                  can get started with VicForms.
                </Text>
              </Box>

              <Section title="Organisation details">
                <GridItem rowSpan={1} colSpan={[4]}>
                  <TextInput
                    name="organisationName"
                    label="Organisation name"
                    isRequired
                  />
                </GridItem>
                <GridItem rowSpan={1} colSpan={[4]}>
                  <TextInput name="address" label="Address" isRequired />
                </GridItem>
                <GridItem rowSpan={1} colSpan={[3, 2]}>
                  <TextInput name="abn" type="number" label="ABN" isRequired />
                </GridItem>
              </Section>

              <Section title="Set up your username">
                <GridItem rowSpan={1} colSpan={[4]}>
                  <TextInput
                    name="userName"
                    label="Email"
                    type="email"
                    isRequired
                    helperText="This email address will be the username for your
                    organisation to access VicForms."
                  />
                </GridItem>
              </Section>

              <ButtonGroup justifyContent={"flex-end"}>
                <Button
                  type="submit"
                  rightIcon={<ArrowForwardIcon />}
                  colorScheme={"primary"}
                  isLoading={isSubmitting}
                >
                  Continue
                </Button>
              </ButtonGroup>
            </VStack>
          </form>
        );
      }}
    </Formik>
  );
};

export default Organisation;
